import {ApiConfig} from "./ApiConfig";

export class ExternalApplication {
  public partitionId!: number;
  public id?: number;
  public email!: string;
  public description!: string;
  public language?: string;
  public enabled!: boolean;
  public apiConfigMap!: Record<string, ApiConfig>;
  linkedPartitions?: number[];
}
